import { OsmAPIList } from '@/api'

const api = new OsmAPIList();

export default {
  getClaimList({ state, commit }, params) {
    return new Promise((resolve, reject) => {
      api.getClaimList(params, (json) => {
        switch (json.status) {
          case 200:
            resolve(json);
            break;
          default:
            reject(json);
            break;
        }
      }, (err) => {
        reject(err);
      })
    })
  },

  createClaim({ state, commit }, params) {
    return new Promise((resolve, reject) => {
      api.createClaim(params, (json) => {
        switch (json.status) {
          case 200:
            commit({ type: 'setClaimID', ID: json.data });
            commit({ type: 'setNextWorkFlowStep', nextStep: 1 });
            resolve(json);
            break;
          default:
            reject(json);
            break;
        }
      }, (err) => {
        reject(err);
      })
    })
  },

  rejectClaim({ state, commit }, params) {
    return new Promise((resolve, reject) => {
      api.rejectClaim(params, (json) => {
        switch (json.status) {
          case 200:
            resolve(json);
            break;
          default:
            reject(json);
            break;
        }
      }, (err) => {
        reject(err);
      })
    })
  },

  approveClaim({ state, commit }, params) {
    return new Promise((resolve, reject) => {
      api.approveClaim(params, (json) => {
        switch (json.status) {
          case 200:
            commit({ type: 'setNextWorkFlowStep', nextStep: 2 });
            resolve(json);
            break;
          default:
            reject(json);
            break;
        }
      }, (err) => {
        reject(err);
      })
    })
  },

  createClaimResult({ state, commit }, params) {
    return new Promise((resolve, reject) => {
      api.createClaimResult(params, (json) => {
        switch (json.status) {
          case 200:
            resolve(json);
            break;
          default:
            reject(json);
            break;
        }
      }, (err) => {
        reject(err);
      })
    })
  },

  completeClaim({ state, commit }, params) {
    return new Promise((resolve, reject) => {
      api.completeClaim(params, (json) => {
        switch (json.status) {
          case 200:
            commit({ type: 'setNextWorkFlowStep', nextStep: 0 });
            resolve(json);
            break;
          default:
            reject(json);
            break;
        }
      }, (err) => {
        reject(err);
      })
    })
  },

  editClaimResult({ state, commit }, params) {
    return new Promise((resolve, reject) => {
      api.editClaimResult(params, (json) => {
        switch (json.status) {
          case 200:
            resolve(json);
            break;
          default:
            reject(json);
            break;
        }
      }, (err) => {
        reject(err);
      })
    })
  },

  getClaimDetail({ state, commit }, params) {
    return new Promise((resolve, reject) => {
      api.getClaimDetail(params, (json) => {
        switch (json.status) {
          case 200:
            resolve(json);
            break;
          default:
            reject(json);
            break;
        }
      }, (err) => {
        reject(err);
      })
    })
  },

  editClaim({ state, commit }, params) {
    return new Promise((resolve, reject) => {
      api.editClaim(params, (json) => {
        switch (json.status) {
          case 200:
            resolve(json);
            break;
          default:
            reject(json);
            break;
        }
      }, (err) => {
        reject(err);
      })
    })
  }

}



// WEBPACK FOOTER //
// ./src/Osm/Claim/store/actions.js